import { DefaultRootState } from 'react-redux';
import { Middleware } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { LOCATION_CHANGE } from 'connected-react-router';
import { Location } from 'history';

import Analytics from '@hh.ru/analytics-js';
import clickmeScreenShown, {
    HhtmSource,
} from '@hh.ru/analytics-js-events/build/clickme/employer/common/clickme_screen_shown';

import { Action } from 'store/createReducer';
import { BatchDispatch } from 'store/middlewares/batched';
import { getRoute } from 'store/middlewares/fetchRouter';

interface TrackUrlAction extends Action {
    payload: {
        isFirstRendering: boolean;
        location: Location;
    };
}

declare global {
    interface Window {
        globalVars: {
            analyticsParams: {
                hhtmFrom: string;
                hhtmSource: string;
            };
        };
    }
}

const trackUrlMiddleware: Middleware<
    unknown,
    DefaultRootState,
    ThunkDispatch<DefaultRootState, unknown, TrackUrlAction>
> =
    ({ getState }) =>
    (next: BatchDispatch<TrackUrlAction>) =>
    (action: TrackUrlAction | TrackUrlAction[]) => {
        const locationChangeAction = (Array.isArray(action) ? action : [action])?.find?.(
            (action) => action?.type === LOCATION_CHANGE
        );
        if (locationChangeAction) {
            Analytics.trackPageView();

            const { router } = getState();
            const oldPathname = router?.location?.pathname;
            const { isFirstRendering } = locationChangeAction?.payload;
            const newPathname = locationChangeAction?.payload?.location?.pathname;

            window.globalVars.analyticsParams.hhtmFrom = isFirstRendering ? '' : getRoute(oldPathname).pageName;

            const { pageName, sendScreenShownAnalytics } = getRoute(newPathname);
            const hhtmSource = pageName as HhtmSource;

            window.globalVars.analyticsParams.hhtmSource = hhtmSource;

            if (sendScreenShownAnalytics) {
                clickmeScreenShown({ hhtmSource });
            }
        }
        return next(action);
    };

export default trackUrlMiddleware;
